/* eslint-disable @next/next/no-img-element */
import React from "react";
import styles from "./vlog_video_cared.module.scss";
import Link from "next/link";
import PlayButtonWithRipple from "../../play_btn_with_ripple";
import moment from "moment";
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";

export const VlogVideoCard = ({ item }) => {
  return (
    <div className={styles.wrapper}>
      <Link legacyBehavior href={`/vlog/${item?.slug}`}>
        <a>
          <div className={styles.image_wrapper}>
            <Image
              layout="responsive"
              width={270}
              height={145}
              blurDataURL={getAssets(
                "assets/images/image_placeholder_big.webp"
              )}
              placeholder="blur"
              className=""
              src={
                item?.thumbnail?.src ||
                item?.featuredImage?.src ||
                getAssets("assets/images/image_placeholder_big.webp")
              }
              alt={item?.title}
            />
            <PlayButtonWithRipple medium ripple={false} />
          </div>
        </a>
      </Link>
      <div className={styles.details_wrapper}>
        <Link legacyBehavior href={`/vlog/${item?.slug}`}>
          <a className={styles.title}>{item?.title}</a>
        </Link>
        <div className={styles.details}>
          {item?.totalView} Views ●{" "}
          {moment(item?.publishedDate).format("MMMM DD, YYYY")}
        </div>
      </div>
    </div>
  );
};

export default VlogVideoCard;
